import ReconnectingWebSocket from "reconnecting-websocket";
import { HandlerRegistry, registerClientHandlers } from "@/network/handlers";

export default class SocketManager {
  url: string;
  options: any;
  ws: any;
  messageQueue: any[];
  isConnected: boolean = false;

  constructor(url: string, options: any) {
    this.url = url;
    this.options = options;
    this.ws = null;
    this.messageQueue = [];

    registerClientHandlers();
  }

  connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.ws = new ReconnectingWebSocket(this.url, [], this.options);

      this.ws.onopen = (event) => {
        console.log("Connected to server");

        // Send any queued messages
        while (this.messageQueue.length > 0) {
          const message = this.messageQueue.shift();
          this.ws.send(message);
        }
        
        this.isConnected = true;
        resolve(); // Resolve the promise when connection opens
      };

      this.ws.onmessage = (message: { data: any }) => {
        HandlerRegistry.handleMessage(message.data);
      };

      this.ws.onclose = () => {
        this.isConnected = false;
        console.log("Connection closed");
      };

      this.ws.onerror = (error: any) => {
        console.error("WebSocket error", error);
        reject(error); // Reject the promise on error
      };
    });
  }

  sendMessage(message: any) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(message);
    } else {
      console.error("WebSocket is not open, queueing message");
      this.messageQueue.push(message);
    }
  }

  close() {
    if (this.ws) {
      this.ws.close();
    }
  }
}
